import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Logo from "../Images/CK-Logo-removebg-preview-removebg-preview.png";

function Navbar() {

  const [services, setServices] = useState([]);
  const [serviceItems, setServiceItems] = useState({});
  const [activeDropdown, setActiveDropdown] = useState(null);

  // ======================
  // SLUG FUNCTION
  // ======================
  const slugify = (text) => {
    return text
      ?.toLowerCase()
      ?.trim()
      ?.replace(/&/g, "and")
      ?.replace(/[^\w\s-]/g, "")
      ?.replace(/\s+/g, "-");
  };

  // ======================
  // GET SERVICE TYPES
  // ======================
  const getServiceTypes = async () => {

    try {

      const { data } = await axios.get(
        "https://api.compliancekare.com/api/Compliance/GetServiceTypes"
      );

      setServices(data.data || []);

    } catch (error) {

      console.error(error);

    }
  };

  useEffect(() => {

    getServiceTypes();

  }, []);

  // ======================
  // GET SERVICES BY TYPE
  // ======================
  const getServicesByTypeId = async (id) => {

    // API बार-बार call न हो
    if (serviceItems[id]) return;

    try {

      const { data } = await axios.get(
        `https://api.compliancekare.com/api/Compliance/ServicesByTypeId?ServiceTypeId=${id}`
      );

      setServiceItems((prev) => ({
        ...prev,
        [id]: data.data || [],
      }));

    } catch (error) {

      console.error(error);

    }
  };

  // ======================
  // DROPDOWN OPEN
  // ======================
  const handleDropdownOpen = (id) => {

    setActiveDropdown(id);

    getServicesByTypeId(id);

  };

  // ======================
  // DROPDOWN CLOSE
  // ======================
  const handleDropdownClose = () => {

    setActiveDropdown(null);

  };

  // ======================
  // MOBILE CLICK
  // ======================
  const handleDropdownClick = (id) => {

    if (activeDropdown === id) {

      handleDropdownClose();

    } else {

      handleDropdownOpen(id);

    }
  };

  // ======================
  // NAVBAR
  // ======================
  return (

    <nav
      className="navbar navbar-expand-lg sticky-top shadow-sm"
      style={{
        padding: "12px 0",
        backgroundColor: "#ffffff",
      }}
    >

      <div className="container">

        {/* ======================
            LOGO
        ====================== */}
        <Link
          to="/"
          className="navbar-brand m-0 p-0"
          style={{
            backgroundColor: "#ffffff",
          }}
        >

          <img
            src={Logo}
            alt="logo"
            style={{
              height: "90px",
              width: "180px",
              objectFit: " cover",
              display: "block",
              backgroundColor: "#ffffff",
            }}
          />

        </Link>

        {/* ======================
            TOGGLE BUTTON
        ====================== */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#nav"
        >

          <span className="navbar-toggler-icon"></span>

        </button>

        {/* ======================
            MENU
        ====================== */}
        <div
          className="collapse navbar-collapse"
          id="nav"
        >

          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-3">

            {/* ======================
                HOME
            ====================== */}
            <li className="nav-item">

              <Link
                to="/"
                className="nav-link"
                style={{
                  color: "#000",
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                Home
              </Link>

            </li>

            {/* ======================
                SERVICES
            ====================== */}
            {services.map((service) => (

              <li
                key={service.id}
                className="nav-item dropdown"

                onMouseEnter={() =>
                  handleDropdownOpen(service.id)
                }

                onMouseLeave={handleDropdownClose}
              >

                <span
                  className="nav-link dropdown-toggle"

                  style={{
                    cursor: "pointer",
                    color: "#000",
                    fontWeight: "700",
                    fontSize: "16px",
                  }}

                  onClick={() =>
                    handleDropdownClick(service.id)
                  }
                >
                  {service.serviceTypeName}
                </span>

                {/* ======================
                    DROPDOWN
                ====================== */}
                <ul
                  className={`dropdown-menu border-0 shadow ${
                    activeDropdown === service.id
                      ? "show"
                      : ""
                  }`}

                  style={{
                    minWidth: "260px",
                    borderRadius: "12px",
                    padding: "10px 0",
                  }}
                >

                  {serviceItems[service.id]?.length > 0 ? (

                    serviceItems[service.id].map((item) => (

                      <li key={item.id}>

                        <Link
                          className="dropdown-item"

                          to={`/service/${slugify(
                            item.serviceName
                          )}`}

                          state={{ id: item.id }}

                          style={{
                            padding: "10px 18px",
                            fontWeight: "500",
                            transition: "0.3s",
                          }}
                        >
                          {item.serviceName}
                        </Link>

                      </li>

                    ))

                  ) : (

                    <li
                      className="dropdown-item"
                      style={{
                        padding: "10px 18px",
                      }}
                    >
                      Loading...
                    </li>

                  )}

                </ul>

              </li>

            ))}

            {/* ======================
                CONTACT BUTTON
            ====================== */}
            <li className="nav-item ms-lg-3 mt-3 mt-lg-0">

              <Link
                to="/contact"

                className="btn rounded-pill px-4 py-2 fw-bold"

                style={{
                  backgroundColor: "#115886",
                  color: "#fff",
                  border: "none",
                  fontSize: "15px",
                }}
              >
                Contact
              </Link>

            </li>

          </ul>

        </div>

      </div>

    </nav>
  );
}

export default Navbar;